import type { PlannerTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

export const MicrosoftTeamsIcon = () => (
  <svg
    data-testid={getTestId<PlannerTestIds>('microsoft-teams-icon')}
    aria-hidden="true"
    width="16"
    height="16"
    role="presentation"
    focusable="false"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2693_40124)">
      <path
        d="M10.6333 6.44971H14.0774C14.4027 6.44971 14.6665 6.71346 14.6665 7.03884V10.1759C14.6665 11.3718 13.6971 12.3412 12.5012 12.3412H12.491C11.2952 12.3413 10.3256 11.3721 10.3254 10.1762C10.3254 10.1761 10.3254 10.176 10.3254 10.1759V6.75761C10.3254 6.58754 10.4633 6.44971 10.6333 6.44971Z"
        fill="#5059C9"
      />
      <path
        d="M12.9613 5.82976C13.7319 5.82976 14.3566 5.20504 14.3566 4.43441C14.3566 3.66378 13.7319 3.03906 12.9613 3.03906C12.1906 3.03906 11.5659 3.66378 11.5659 4.43441C11.5659 5.20504 12.1906 5.82976 12.9613 5.82976Z"
        fill="#5059C9"
      />
      <path
        d="M8.62002 5.82988C9.73316 5.82988 10.6355 4.9275 10.6355 3.81435C10.6355 2.70121 9.73316 1.79883 8.62002 1.79883C7.50687 1.79883 6.60449 2.70121 6.60449 3.81435C6.60449 4.9275 7.50687 5.82988 8.62002 5.82988Z"
        fill="#7B83EB"
      />
      <path
        d="M11.3075 6.44971H5.62256C5.30108 6.45766 5.04671 6.72447 5.05419 7.04601V10.624C5.00926 12.5534 6.53574 14.1544 8.46507 14.2016C10.3944 14.1544 11.9208 12.5534 11.8759 10.624V7.04601C11.8834 6.72447 11.6291 6.45766 11.3075 6.44971Z"
        fill="#7B83EB"
      />
      <path
        opacity="0.1"
        d="M8.77505 6.44971V11.4637C8.7735 11.6937 8.63417 11.9002 8.42156 11.9877C8.35384 12.0164 8.2811 12.0311 8.20758 12.0312H5.32696C5.28664 11.9289 5.24944 11.8265 5.21845 11.7211C5.10993 11.3653 5.05453 10.9954 5.05412 10.6234V7.04506C5.04664 6.72405 5.30058 6.45766 5.62153 6.44971H8.77505Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M8.46499 6.44971V11.7738C8.46499 11.8473 8.45022 11.92 8.42156 11.9877C8.33404 12.2003 8.12748 12.3397 7.89752 12.3412H5.47269C5.41999 12.2389 5.3704 12.1366 5.32696 12.0312C5.28353 11.9258 5.24944 11.8265 5.21845 11.7211C5.10993 11.3653 5.05453 10.9954 5.05412 10.6234V7.04506C5.04664 6.72405 5.30058 6.45766 5.62153 6.44971H8.46499Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M8.46499 6.44971V11.1536C8.4626 11.466 8.20997 11.7187 7.89758 11.721H5.21845C5.10993 11.3652 5.05453 10.9953 5.05412 10.6233V7.04506C5.04664 6.72405 5.30058 6.45766 5.62153 6.44971H8.46499Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M8.15488 6.44971V11.1536C8.15248 11.466 7.89985 11.7187 7.58746 11.721H5.21845C5.10993 11.3652 5.05453 10.9953 5.05412 10.6233V7.04506C5.04664 6.72405 5.30058 6.45766 5.62153 6.44971H8.15488Z"
        fill="black"
      />
      <path
        opacity="0.1"
        d="M8.77517 4.84665V5.82343C8.72247 5.82654 8.67288 5.82965 8.62011 5.82965C8.56735 5.82965 8.51782 5.82654 8.46505 5.82343C8.36037 5.81649 8.25657 5.79986 8.155 5.77383C7.5271 5.62512 7.00833 5.18476 6.75965 4.58935C6.71687 4.48939 6.68361 4.38554 6.6604 4.2793H8.2077C8.52063 4.28043 8.77398 4.53378 8.77517 4.84665Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M8.46517 5.1572V5.82391C8.36049 5.81697 8.25669 5.80034 8.15512 5.77432C7.52722 5.6256 7.00845 5.18525 6.75977 4.58984H7.89776C8.21063 4.59098 8.46398 4.84433 8.46517 5.1572Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M8.46517 5.1572V5.82391C8.36049 5.81697 8.25669 5.80034 8.15512 5.77432C7.52722 5.6256 7.00845 5.18525 6.75977 4.58984H7.89776C8.21063 4.59098 8.46398 4.84433 8.46517 5.1572Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M8.15512 5.15726V5.77432C7.52722 5.6256 7.00845 5.18525 6.75977 4.58984H7.5877C7.90057 4.59104 8.15392 4.84439 8.15512 5.15726Z"
        fill="black"
      />
      <path
        d="M1.90162 4.58984H7.58658C7.90046 4.58984 8.15495 4.84433 8.15495 5.15821V10.8432C8.15495 11.1571 7.90046 11.4115 7.58658 11.4115H1.90162C1.58774 11.4115 1.33325 11.1571 1.33325 10.8432V5.15821C1.33325 4.84433 1.58774 4.58984 1.90162 4.58984Z"
        fill="url(#a)"
      />
      <path
        d="M6.24018 6.75364H5.10374V9.84823H4.37971V6.75364H3.24854V6.15332H6.24018V6.75364Z"
        fill="transparent"
      />
    </g>
    <defs>
      <linearGradient
        id="a"
        x1="2.51832"
        y1="4.14573"
        x2="6.96989"
        y2="11.8557"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A62C3" />
        <stop offset="0.5" stopColor="#4D55BD" />
        <stop offset="1" stopColor="#3940AB" />
      </linearGradient>
      <clipPath>
        <rect
          width="13.3333"
          height="12.4031"
          fill="transparent"
          transform="translate(1.33325 1.79883)"
        />
      </clipPath>
    </defs>
  </svg>
);
